module.exports = __webpack_public_path__ + "static/img/icon-mine-avatar.b89a37b7.png";